import { render, staticRenderFns } from "./news-form-page.vue?vue&type=template&id=4a4cb1f0&"
import script from "./news-form-page.vue?vue&type=script&lang=js&"
export * from "./news-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports